module.exports = __webpack_public_path__ + "img/d6506-none.974ab00d.png";